import config from "../../config/config";
import "./jquery.min";
///<jscompress sourcefile="Math.uuid.js" />
/*!
Math.uuid.js (v1.4)

Copyright (c) 2010 Robert Kieffer
Dual licensed under the MIT and GPL licenses.
*/

/*
 * Generate a random uuid.
 *
 * USAGE: Math.uuid(length, radix)
 *   length - the desired number of characters
 *   radix  - the number of allowable values for each character.
 *
 * EXAMPLES:
 *   // No arguments  - returns RFC4122, version 4 ID
 *   >>> Math.uuid()
 *   "92329D39-6F5C-4520-ABFC-AAB64544E172"
 *
 *   // One argument - returns ID of the specified length
 *   >>> Math.uuid(15)     // 15 character ID (default base=62)
 *   "VcydxgltxrVZSTV"
 *
 *   // Two arguments - returns ID of the specified length, and radix. (Radix must be <= 62)
 *   >>> Math.uuid(8, 2)  // 8 character ID (base=2)
 *   "01001010"
 *   >>> Math.uuid(8, 10) // 8 character ID (base=10)
 *   "47473046"
 *   >>> Math.uuid(8, 16) // 8 character ID (base=16)
 *   "098F4D35"
 */
(function () {
  // Private array of chars to use
  var CHARS =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");

  Math.uuid = function (len, radix) {
    var chars = CHARS,
      uuid = [],
      i;
    radix = radix || chars.length;

    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
      // rfc4122, version 4 form
      var r;

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
      uuid[14] = "4";

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16);
          uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
        }
      }
    }

    return uuid.join("");
  };

  // A more performant, but slightly bulkier, RFC4122v4 solution.  We boost performance
  // by minimizing calls to random()
  Math.uuidFast = function () {
    var chars = CHARS,
      uuid = new Array(36),
      rnd = 0,
      r;
    for (var i = 0; i < 36; i++) {
      if (i == 8 || i == 13 || i == 18 || i == 23) {
        uuid[i] = "-";
      } else if (i == 14) {
        uuid[i] = "4";
      } else {
        if (rnd <= 0x02) rnd = (0x2000000 + Math.random() * 0x1000000) | 0;
        r = rnd & 0xf;
        rnd = rnd >> 4;
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
    return uuid.join("");
  };

  // A more compact, but less performant, RFC4122v4 solution:
  Math.uuidCompact = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
})();
///<jscompress sourcefile="base64.js" />
(function (undefined) {
  var Base64 = {
    _keyStr:
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function (e) {
      var t = "";
      var n, r, i, s, o, u, a;
      var f = 0;
      e = Base64._utf8_encode(e);
      while (f < e.length) {
        n = e.charCodeAt(f++);
        r = e.charCodeAt(f++);
        i = e.charCodeAt(f++);
        s = n >> 2;
        o = ((n & 3) << 4) | (r >> 4);
        u = ((r & 15) << 2) | (i >> 6);
        a = i & 63;
        if (isNaN(r)) {
          u = a = 64;
        } else if (isNaN(i)) {
          a = 64;
        }else{
          // 注释
        }
        t =
          t +
          this._keyStr.charAt(s) +
          this._keyStr.charAt(o) +
          this._keyStr.charAt(u) +
          this._keyStr.charAt(a);
      }
      return t;
    },
    decode: function (e) {
      var t = "";
      var n, r, i;
      var s, o, u, a;
      var f = 0;
      e = e.replace(/[^A-Za-z0-9+/=]/g, "");
      while (f < e.length) {
        s = this._keyStr.indexOf(e.charAt(f++));
        o = this._keyStr.indexOf(e.charAt(f++));
        u = this._keyStr.indexOf(e.charAt(f++));
        a = this._keyStr.indexOf(e.charAt(f++));
        n = (s << 2) | (o >> 4);
        r = ((o & 15) << 4) | (u >> 2);
        i = ((u & 3) << 6) | a;
        t = t + String.fromCharCode(n);
        if (u != 64) {
          t = t + String.fromCharCode(r);
        }
        if (a != 64) {
          t = t + String.fromCharCode(i);
        }
      }
      t = Base64._utf8_decode(t);
      return t;
    },
    _utf8_encode: function (e) {
      e = e.replace(/rn/g, "n");
      var t = "";
      for (var n = 0; n < e.length; n++) {
        var r = e.charCodeAt(n);
        if (r < 128) {
          t += String.fromCharCode(r);
        } else if (r > 127 && r < 2048) {
          t += String.fromCharCode((r >> 6) | 192);
          t += String.fromCharCode((r & 63) | 128);
        } else {
          t += String.fromCharCode((r >> 12) | 224);
          t += String.fromCharCode(((r >> 6) & 63) | 128);
          t += String.fromCharCode((r & 63) | 128);
        }
      }
      return t;
    },
    _utf8_decode: function (e) {
      var t = "";
      var n = 0;
      var r = 0;
      var c1 = 0;
      var c2 = 0;
      var c3 = 0;
      while (n < e.length) {
        r = e.charCodeAt(n);
        if (r < 128) {
          t += String.fromCharCode(r);
          n++;
        } else if (r > 191 && r < 224) {
          c2 = e.charCodeAt(n + 1);
          t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
          n += 2;
        } else {
          c2 = e.charCodeAt(n + 1);
          c3 = e.charCodeAt(n + 2);
          t += String.fromCharCode(
            ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
          );
          n += 3;
        }
      }
      return t;
    },
  };
  window.Base64 = Base64;
})();
///<jscompress sourcefile="jquery.sha1.js" />

/**
 * jQuery SHA1 hash algorithm function
 *      <code>
 *              Calculate the sha1 hash of a String
 *              String $.sha1 ( String str )
 *      </code>
 *
 * Calculates the sha1 hash of str using the US Secure Hash Algorithm 1.
 * SHA-1 the Secure Hash Algorithm (SHA) was developed by NIST and is specified in the Secure Hash Standard (SHS, FIPS 180).
 * This script is used to process variable length message into a fixed-length output using the SHA-1 algorithm. It is fully compatible with UTF-8 encoding.
 * If you plan using UTF-8 encoding in your project don't forget to set the page encoding to UTF-8 (Content-Type meta tag).
 * This function orginally get from the WebToolkit and rewrite for using as the jQuery plugin.
 *
 * Example
 *      Code
 *              <code>
 *                      $.sha1("I'm Persian.");
 *              </code>
 *      Result
 *              <code>
 *                      "1d302f9dc925d62fc859055999d2052e274513ed"
 *              </code>
 *
 * @param {jQuery} {sha1:function(string))
 * @return string
 */

(function ($) {
  var rotateLeft = function (lValue, iShiftBits) {
    return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
  };

  var lsbHex = function (value) {
    var string = "";
    var i;
    var vh;
    var vl;
    for (i = 0; i <= 6; i += 2) {
      vh = (value >>> (i * 4 + 4)) & 0x0f;
      vl = (value >>> (i * 4)) & 0x0f;
      string += vh.toString(16) + vl.toString(16);
    }
    return string;
  };

  var cvtHex = function (value) {
    var string = "";
    var i;
    var v;
    for (i = 7; i >= 0; i--) {
      v = (value >>> (i * 4)) & 0x0f;
      string += v.toString(16);
    }
    return string;
  };

  var uTF8Encode = function (string) {
    string = string.replace(/\x0d\x0a/g, "\x0a");
    var output = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        output += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        output += String.fromCharCode((c >> 6) | 192);
        output += String.fromCharCode((c & 63) | 128);
      } else {
        output += String.fromCharCode((c >> 12) | 224);
        output += String.fromCharCode(((c >> 6) & 63) | 128);
        output += String.fromCharCode((c & 63) | 128);
      }
    }
    return output;
  };

  $.extend({
    sha1: function (string) {
      var blockstart;
      var i, j;
      var W = new Array(80);
      var H0 = 0x67452301;
      var H1 = 0xefcdab89;
      var H2 = 0x98badcfe;
      var H3 = 0x10325476;
      var H4 = 0xc3d2e1f0;
      var A, B, C, D, E;
      var tempValue;
      string = uTF8Encode(string);
      var stringLength = string.length;
      var wordArray = new Array();
      for (i = 0; i < stringLength - 3; i += 4) {
        j =
          (string.charCodeAt(i) << 24) |
          (string.charCodeAt(i + 1) << 16) |
          (string.charCodeAt(i + 2) << 8) |
          string.charCodeAt(i + 3);
        wordArray.push(j);
      }
      switch (stringLength % 4) {
        case 0:
          i = 0x080000000;
          break;
        case 1:
          i = (string.charCodeAt(stringLength - 1) << 24) | 0x0800000;
          break;
        case 2:
          i =
            (string.charCodeAt(stringLength - 2) << 24) |
            (string.charCodeAt(stringLength - 1) << 16) |
            0x08000;
          break;
        case 3:
          i =
            (string.charCodeAt(stringLength - 3) << 24) |
            (string.charCodeAt(stringLength - 2) << 16) |
            (string.charCodeAt(stringLength - 1) << 8) |
            0x80;
          break;
          default:
            break;
      }
      wordArray.push(i);
      while (wordArray.length % 16 != 14) wordArray.push(0);
      wordArray.push(stringLength >>> 29);
      wordArray.push((stringLength << 3) & 0x0ffffffff);
      for (blockstart = 0; blockstart < wordArray.length; blockstart += 16) {
        for (i = 0; i < 16; i++) W[i] = wordArray[blockstart + i];
        for (i = 16; i <= 79; i++)
          W[i] = rotateLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for (i = 0; i <= 19; i++) {
          tempValue =
            (rotateLeft(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) &
            0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        for (i = 20; i <= 39; i++) {
          tempValue =
            (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) &
            0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        for (i = 40; i <= 59; i++) {
          tempValue =
            (rotateLeft(A, 5) +
              ((B & C) | (B & D) | (C & D)) +
              E +
              W[i] +
              0x8f1bbcdc) &
            0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        for (i = 60; i <= 79; i++) {
          tempValue =
            (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) &
            0x0ffffffff;
          E = D;
          D = C;
          C = rotateLeft(B, 30);
          B = A;
          A = tempValue;
        }
        H0 = (H0 + A) & 0x0ffffffff;
        H1 = (H1 + B) & 0x0ffffffff;
        H2 = (H2 + C) & 0x0ffffffff;
        H3 = (H3 + D) & 0x0ffffffff;
        H4 = (H4 + E) & 0x0ffffffff;
      }
       tempValue =
        cvtHex(H0) + cvtHex(H1) + cvtHex(H2) + cvtHex(H3) + cvtHex(H4);
      return tempValue.toLowerCase();
    },
  });
})(jQuery);
///<jscompress sourcefile="security.js" />
/*
 * RSA, a suite of routines for performing RSA public-key computations in JavaScript.
 * Copyright 1998-2005 David Shapiro.
 * Dave Shapiro
 * dave@ohdave.com
 * changed by Fuchun, 2010-05-06
 * fcrpg2005@gmail.com
 */

(function ($w) {
  if (typeof $w.RSAUtils === "undefined") {
    var RSAUtils = ($w.RSAUtils = {});
  } else {
    var RSAUtils = $w.RSAUtils;
  }
  var biRadixBase = 2;
  var biRadixBits = 16;
  var bitsPerDigit = biRadixBits;
  var biRadix = 1 << 16; // = 2^16 = 65536
  var biHalfRadix = biRadix >>> 1;
  var biRadixSquared = biRadix * biRadix;
  var maxDigitVal = biRadix - 1;
  var maxInteger = 9999999999999998;

  //maxDigits:
  //Change this to accommodate your largest number size. Use setMaxDigits()
  //to change it!
  //
  //In general, if you're working with numbers of size N bits, you'll need 2*N
  //bits of storage. Each digit holds 16 bits. So, a 1024-bit key will need
  //
  //1024 * 2 / 16 = 128 digits of storage.

  var maxDigits;
  var ZERO_ARRAY;
  var bigZero, bigOne;

  var BigInt = ($w.BigInt = function (flag) {
    if (typeof flag == "boolean" && flag == true) {
      this.digits = null;
    } else {
      this.digits = ZERO_ARRAY.slice(0);
    }
    this.isNeg = false;
  });

  RSAUtils.setMaxDigits = function (value) {
    maxDigits = value;
    ZERO_ARRAY = new Array(maxDigits);
    for (var iza = 0; iza < ZERO_ARRAY.length; iza++) ZERO_ARRAY[iza] = 0;
    bigZero = new BigInt();
    bigOne = new BigInt();
    bigOne.digits[0] = 1;
  };
  RSAUtils.setMaxDigits(20);

  //The maximum number of digits in base 10 you can convert to an
  //integer without JavaScript throwing up on you.
  var dpl10 = 15;

  RSAUtils.biFromNumber = function (i) {
    var result = new BigInt();
    result.isNeg = i < 0;
    i = Math.abs(i);
    var j = 0;
    while (i > 0) {
      result.digits[j++] = i & maxDigitVal;
      i = Math.floor(i / biRadix);
    }
    return result;
  };

  //lr10 = 10 ^ dpl10
  var lr10 = RSAUtils.biFromNumber(1000000000000000);

  RSAUtils.biFromDecimal = function (s) {
    var isNeg = s.charAt(0) == "-";
    var i = isNeg ? 1 : 0;
    var result;
    // Skip leading zeros.
    while (i < s.length && s.charAt(i) == "0") ++i;
    if (i == s.length) {
      result = new BigInt();
    } else {
      var digitCount = s.length - i;
      var fgl = digitCount % dpl10;
      if (fgl == 0) fgl = dpl10;
      result = RSAUtils.biFromNumber(Number(s.substr(i, fgl)));
      i += fgl;
      while (i < s.length) {
        result = RSAUtils.biAdd(
          RSAUtils.biMultiply(result, lr10),
          RSAUtils.biFromNumber(Number(s.substr(i, dpl10)))
        );
        i += dpl10;
      }
      result.isNeg = isNeg;
    }
    return result;
  };

  RSAUtils.biCopy = function (bi) {
    var result = new BigInt(true);
    result.digits = bi.digits.slice(0);
    result.isNeg = bi.isNeg;
    return result;
  };

  RSAUtils.reverseStr = function (s) {
    var result = "";
    for (var i = s.length - 1; i > -1; --i) {
      result += s.charAt(i);
    }
    return result;
  };

  var hexatrigesimalToChar = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];

  RSAUtils.biToString = function (x, radix) {
    // 2 <= radix <= 36
    var b = new BigInt();
    b.digits[0] = radix;
    var qr = RSAUtils.biDivideModulo(x, b);
    var result = hexatrigesimalToChar[qr[1].digits[0]];
    let digit = 0;
    while (RSAUtils.biCompare(qr[0], bigZero) == 1) {
      qr = RSAUtils.biDivideModulo(qr[0], b);
      digit = qr[1].digits[0];
      result += hexatrigesimalToChar[qr[1].digits[0]];
    }
    return (x.isNeg ? "-" : "") + RSAUtils.reverseStr(result);
  };

  RSAUtils.biToDecimal = function (x) {
    var b = new BigInt();
    b.digits[0] = 10;
    var qr = RSAUtils.biDivideModulo(x, b);
    var result = String(qr[1].digits[0]);
    while (RSAUtils.biCompare(qr[0], bigZero) == 1) {
      qr = RSAUtils.biDivideModulo(qr[0], b);
      result += String(qr[1].digits[0]);
    }
    return (x.isNeg ? "-" : "") + RSAUtils.reverseStr(result);
  };

  var hexToChar = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
  ];

  RSAUtils.digitToHex = function (n) {
    var mask = 0xf;
    var result = "";
    for (var i = 0; i < 4; ++i) {
      result += hexToChar[n & mask];
      n >>>= 4;
    }
    return RSAUtils.reverseStr(result);
  };

  RSAUtils.biToHex = function (x) {
    var result = "";
    var n = RSAUtils.biHighIndex(x);
    for (var i = RSAUtils.biHighIndex(x); i > -1; --i) {
      result += RSAUtils.digitToHex(x.digits[i]);
    }
    return result;
  };

  RSAUtils.charToHex = function (c) {
    var ZERO = 48;
    var NINE = ZERO + 9;
    var littleA = 97;
    var littleZ = littleA + 25;
    var bigA = 65;
    var bigZ = 65 + 25;
    var result;

    if (c >= ZERO && c <= NINE) {
      result = c - ZERO;
    } else if (c >= bigA && c <= bigZ) {
      result = 10 + c - bigA;
    } else if (c >= littleA && c <= littleZ) {
      result = 10 + c - littleA;
    } else {
      result = 0;
    }
    return result;
  };

  RSAUtils.hexToDigit = function (s) {
    var result = 0;
    var sl = Math.min(s.length, 4);
    for (var i = 0; i < sl; ++i) {
      result <<= 4;
      result |= RSAUtils.charToHex(s.charCodeAt(i));
    }
    return result;
  };

  RSAUtils.biFromHex = function (s) {
    var result = new BigInt();
    var sl = s.length;
    for (var i = sl, j = 0; i > 0; i -= 4, ++j) {
      result.digits[j] = RSAUtils.hexToDigit(
        s.substr(Math.max(i - 4, 0), Math.min(i, 4))
      );
    }
    return result;
  };

  RSAUtils.biFromString = function (s, radix) {
    var isNeg = s.charAt(0) == "-";
    var istop = isNeg ? 1 : 0;
    var result = new BigInt();
    var place = new BigInt();
    place.digits[0] = 1; // radix^0
    for (var i = s.length - 1; i >= istop; i--) {
      var c = s.charCodeAt(i);
      var digit = RSAUtils.charToHex(c);
      var biDigit = RSAUtils.biMultiplyDigit(place, digit);
      result = RSAUtils.biAdd(result, biDigit);
      place = RSAUtils.biMultiplyDigit(place, radix);
    }
    result.isNeg = isNeg;
    return result;
  };

  RSAUtils.biDump = function (b) {
    return (b.isNeg ? "-" : "") + b.digits.join(" ");
  };

  RSAUtils.biAdd = function (x, y) {
    var result;

    if (x.isNeg != y.isNeg) {
      y.isNeg = !y.isNeg;
      result = RSAUtils.biSubtract(x, y);
      y.isNeg = !y.isNeg;
    } else {
      result = new BigInt();
      var c = 0;
      var n;
      for (var i = 0; i < x.digits.length; ++i) {
        n = x.digits[i] + y.digits[i] + c;
        result.digits[i] = n % biRadix;
        c = Number(n >= biRadix);
      }
      result.isNeg = x.isNeg;
    }
    return result;
  };

  RSAUtils.biSubtract = function (x, y) {
    var result;
    if (x.isNeg != y.isNeg) {
      y.isNeg = !y.isNeg;
      result = RSAUtils.biAdd(x, y);
      y.isNeg = !y.isNeg;
    } else {
      result = new BigInt();
      var n, c;
      c = 0;
      for (var i = 0; i < x.digits.length; ++i) {
        n = x.digits[i] - y.digits[i] + c;
        result.digits[i] = n % biRadix;
        // Stupid non-conforming modulus operation.
        if (result.digits[i] < 0) result.digits[i] += biRadix;
        c = 0 - Number(n < 0);
      }
      // Fix up the negative sign, if any.
      if (c == -1) {
        c = 0;
        for (var i = 0; i < x.digits.length; ++i) {
          n = 0 - result.digits[i] + c;
          result.digits[i] = n % biRadix;
          // Stupid non-conforming modulus operation.
          if (result.digits[i] < 0) result.digits[i] += biRadix;
          c = 0 - Number(n < 0);
        }
        // Result is opposite sign of arguments.
        result.isNeg = !x.isNeg;
      } else {
        // Result is same sign.
        result.isNeg = x.isNeg;
      }
    }
    return result;
  };

  RSAUtils.biHighIndex = function (x) {
    var result = x.digits.length - 1;
    while (result > 0 && x.digits[result] == 0) --result;
    return result;
  };

  RSAUtils.biNumBits = function (x) {
    var n = RSAUtils.biHighIndex(x);
    var d = x.digits[n];
    var m = (n + 1) * bitsPerDigit;
    var result;
    for (result = m; result > m - bitsPerDigit; --result) {
      if ((d & 0x8000) != 0) break;
      d <<= 1;
    }
    return result;
  };

  RSAUtils.biMultiply = function (x, y) {
    var result = new BigInt();
    var c;
    var n = RSAUtils.biHighIndex(x);
    var t = RSAUtils.biHighIndex(y);
    var u, uv, k;

    for (var i = 0; i <= t; ++i) {
      c = 0;
      k = i;
      for (var j = 0; j <= n; ++j, ++k) {
        uv = result.digits[k] + x.digits[j] * y.digits[i] + c;
        result.digits[k] = uv & maxDigitVal;
        c = uv >>> biRadixBits;
        //c = Math.floor(uv / biRadix);
      }
      result.digits[i + n + 1] = c;
    }
    // Someone give me a logical xor, please.
    result.isNeg = x.isNeg != y.isNeg;
    return result;
  };

  RSAUtils.biMultiplyDigit = function (x, y) {
    var n, c, uv;

    var result = new BigInt();
    n = RSAUtils.biHighIndex(x);
    c = 0;
    for (var j = 0; j <= n; ++j) {
      uv = result.digits[j] + x.digits[j] * y + c;
      result.digits[j] = uv & maxDigitVal;
      c = uv >>> biRadixBits;
      //c = Math.floor(uv / biRadix);
    }
    result.digits[1 + n] = c;
    return result;
  };

  RSAUtils.arrayCopy = function (src, srcStart, dest, destStart, n) {
    var m = Math.min(srcStart + n, src.length);
    for (var i = srcStart, j = destStart; i < m; ++i, ++j) {
      dest[j] = src[i];
    }
  };

  var highBitMasks = [
    0x0000, 0x8000, 0xc000, 0xe000, 0xf000, 0xf800, 0xfc00, 0xfe00, 0xff00,
    0xff80, 0xffc0, 0xffe0, 0xfff0, 0xfff8, 0xfffc, 0xfffe, 0xffff,
  ];

  RSAUtils.biShiftLeft = function (x, n) {
    var digitCount = Math.floor(n / bitsPerDigit);
    var result = new BigInt();
    RSAUtils.arrayCopy(
      x.digits,
      0,
      result.digits,
      digitCount,
      result.digits.length - digitCount
    );
    var bits = n % bitsPerDigit;
    var rightBits = bitsPerDigit - bits;
    for (var i = result.digits.length - 1, i1 = i - 1; i > 0; --i, --i1) {
      result.digits[i] =
        ((result.digits[i] << bits) & maxDigitVal) |
        ((result.digits[i1] & highBitMasks[bits]) >>> rightBits);
    }
    result.digits[0] = (result.digits[i] << bits) & maxDigitVal;
    result.isNeg = x.isNeg;
    return result;
  };

  var lowBitMasks = [
    0x0000, 0x0001, 0x0003, 0x0007, 0x000f, 0x001f, 0x003f, 0x007f, 0x00ff,
    0x01ff, 0x03ff, 0x07ff, 0x0fff, 0x1fff, 0x3fff, 0x7fff, 0xffff,
  ];

  RSAUtils.biShiftRight = function (x, n) {
    var digitCount = Math.floor(n / bitsPerDigit);
    var result = new BigInt();
    RSAUtils.arrayCopy(
      x.digits,
      digitCount,
      result.digits,
      0,
      x.digits.length - digitCount
    );
    var bits = n % bitsPerDigit;
    var leftBits = bitsPerDigit - bits;
    for (var i = 0, i1 = i + 1; i < result.digits.length - 1; ++i, ++i1) {
      result.digits[i] =
        (result.digits[i] >>> bits) |
        ((result.digits[i1] & lowBitMasks[bits]) << leftBits);
    }
    result.digits[result.digits.length - 1] >>>= bits;
    result.isNeg = x.isNeg;
    return result;
  };

  RSAUtils.biMultiplyByRadixPower = function (x, n) {
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, n, result.digits.length - n);
    return result;
  };

  RSAUtils.biDivideByRadixPower = function (x, n) {
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, n, result.digits, 0, result.digits.length - n);
    return result;
  };

  RSAUtils.biModuloByRadixPower = function (x, n) {
    var result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, 0, n);
    return result;
  };

  RSAUtils.biCompare = function (x, y) {
    if (x.isNeg != y.isNeg) {
      return 1 - 2 * Number(x.isNeg);
    }
    for (var i = x.digits.length - 1; i >= 0; --i) {
      if (x.digits[i] != y.digits[i]) {
        if (x.isNeg) {
          return 1 - 2 * Number(x.digits[i] > y.digits[i]);
        } else {
          return 1 - 2 * Number(x.digits[i] < y.digits[i]);
        }
      }
    }
    return 0;
  };

  RSAUtils.biDivideModulo = function (x, y) {
    var nb = RSAUtils.biNumBits(x);
    var tb = RSAUtils.biNumBits(y);
    var origYIsNeg = y.isNeg;
    var q, r;
    if (nb < tb) {
      // |x| < |y|
      if (x.isNeg) {
        q = RSAUtils.biCopy(bigOne);
        q.isNeg = !y.isNeg;
        x.isNeg = false;
        y.isNeg = false;
        r = biSubtract(y, x);
        // Restore signs, 'cause they're references.
        x.isNeg = true;
        y.isNeg = origYIsNeg;
      } else {
        q = new BigInt();
        r = RSAUtils.biCopy(x);
      }
      return [q, r];
    }

    q = new BigInt();
    r = x;

    // Normalize Y.
    var t = Math.ceil(tb / bitsPerDigit) - 1;
    var lambda = 0;
    while (y.digits[t] < biHalfRadix) {
      y = RSAUtils.biShiftLeft(y, 1);
      ++lambda;
      ++tb;
      t = Math.ceil(tb / bitsPerDigit) - 1;
    }
    // Shift r over to keep the quotient constant. We'll shift the
    // remainder back at the end.
    r = RSAUtils.biShiftLeft(r, lambda);
    nb += lambda; // Update the bit count for x.
    var n = Math.ceil(nb / bitsPerDigit) - 1;

    var b = RSAUtils.biMultiplyByRadixPower(y, n - t);
    while (RSAUtils.biCompare(r, b) != -1) {
      ++q.digits[n - t];
      r = RSAUtils.biSubtract(r, b);
    }
    for (var i = n; i > t; --i) {
      var ri = i >= r.digits.length ? 0 : r.digits[i];
      var ri1 = i - 1 >= r.digits.length ? 0 : r.digits[i - 1];
      var ri2 = i - 2 >= r.digits.length ? 0 : r.digits[i - 2];
      var yt = t >= y.digits.length ? 0 : y.digits[t];
      var yt1 = t - 1 >= y.digits.length ? 0 : y.digits[t - 1];
      if (ri == yt) {
        q.digits[i - t - 1] = maxDigitVal;
      } else {
        q.digits[i - t - 1] = Math.floor((ri * biRadix + ri1) / yt);
      }

      var c1 = q.digits[i - t - 1] * (yt * biRadix + yt1);
      var c2 = ri * biRadixSquared + (ri1 * biRadix + ri2);
      while (c1 > c2) {
        --q.digits[i - t - 1];
        c1 = q.digits[i - t - 1] * ((yt * biRadix) | yt1);
        c2 = ri * biRadix * biRadix + (ri1 * biRadix + ri2);
      }

      b = RSAUtils.biMultiplyByRadixPower(y, i - t - 1);
      r = RSAUtils.biSubtract(
        r,
        RSAUtils.biMultiplyDigit(b, q.digits[i - t - 1])
      );
      if (r.isNeg) {
        r = RSAUtils.biAdd(r, b);
        --q.digits[i - t - 1];
      }
    }
    r = RSAUtils.biShiftRight(r, lambda);
    // Fiddle with the signs and stuff to make sure that 0 <= r < y.
    q.isNeg = x.isNeg != origYIsNeg;
    if (x.isNeg) {
      if (origYIsNeg) {
        q = RSAUtils.biAdd(q, bigOne);
      } else {
        q = RSAUtils.biSubtract(q, bigOne);
      }
      y = RSAUtils.biShiftRight(y, lambda);
      r = RSAUtils.biSubtract(y, r);
    }
    // Check for the unbelievably stupid degenerate case of r == -0.
    if (r.digits[0] == 0 && RSAUtils.biHighIndex(r) == 0) r.isNeg = false;

    return [q, r];
  };

  RSAUtils.biDivide = function (x, y) {
    return RSAUtils.biDivideModulo(x, y)[0];
  };

  RSAUtils.biModulo = function (x, y) {
    return RSAUtils.biDivideModulo(x, y)[1];
  };

  RSAUtils.biMultiplyMod = function (x, y, m) {
    return RSAUtils.biModulo(RSAUtils.biMultiply(x, y), m);
  };

  RSAUtils.biPow = function (x, y) {
    var result = bigOne;
    var a = x;
    while (true) {
      if ((y & 1) != 0) result = RSAUtils.biMultiply(result, a);
      y >>= 1;
      if (y == 0) break;
      a = RSAUtils.biMultiply(a, a);
    }
    return result;
  };

  RSAUtils.biPowMod = function (x, y, m) {
    var result = bigOne;
    var a = x;
    var k = y;
    while (true) {
      if ((k.digits[0] & 1) != 0) result = RSAUtils.biMultiplyMod(result, a, m);
      k = RSAUtils.biShiftRight(k, 1);
      if (k.digits[0] == 0 && RSAUtils.biHighIndex(k) == 0) break;
      a = RSAUtils.biMultiplyMod(a, a, m);
    }
    return result;
  };

  $w.BarrettMu = function (m) {
    this.modulus = RSAUtils.biCopy(m);
    this.k = RSAUtils.biHighIndex(this.modulus) + 1;
    var b2k = new BigInt();
    b2k.digits[2 * this.k] = 1; // b2k = b^(2k)
    this.mu = RSAUtils.biDivide(b2k, this.modulus);
    this.bkplus1 = new BigInt();
    this.bkplus1.digits[this.k + 1] = 1; // bkplus1 = b^(k+1)
    this.modulo = BarrettMu_modulo;
    this.multiplyMod = BarrettMu_multiplyMod;
    this.powMod = BarrettMu_powMod;
  };

  function BarrettMu_modulo(x) {
    var $dmath = RSAUtils;
    var q1 = $dmath.biDivideByRadixPower(x, this.k - 1);
    var q2 = $dmath.biMultiply(q1, this.mu);
    var q3 = $dmath.biDivideByRadixPower(q2, this.k + 1);
    var r1 = $dmath.biModuloByRadixPower(x, this.k + 1);
    var r2term = $dmath.biMultiply(q3, this.modulus);
    var r2 = $dmath.biModuloByRadixPower(r2term, this.k + 1);
    var r = $dmath.biSubtract(r1, r2);
    if (r.isNeg) {
      r = $dmath.biAdd(r, this.bkplus1);
    }
    var rgtem = $dmath.biCompare(r, this.modulus) >= 0;
    while (rgtem) {
      r = $dmath.biSubtract(r, this.modulus);
      rgtem = $dmath.biCompare(r, this.modulus) >= 0;
    }
    return r;
  }

  function BarrettMu_multiplyMod(x, y) {
    /*
     x = this.modulo(x);
     y = this.modulo(y);
     */
    var xy = RSAUtils.biMultiply(x, y);
    return this.modulo(xy);
  }

  function BarrettMu_powMod(x, y) {
    var result = new BigInt();
    result.digits[0] = 1;
    var a = x;
    var k = y;
    while (true) {
      if ((k.digits[0] & 1) != 0) result = this.multiplyMod(result, a);
      k = RSAUtils.biShiftRight(k, 1);
      if (k.digits[0] == 0 && RSAUtils.biHighIndex(k) == 0) break;
      a = this.multiplyMod(a, a);
    }
    return result;
  }

  var RSAKeyPair = function (encryptionExponent, decryptionExponent, modulus) {
    var $dmath = RSAUtils;
    this.e = $dmath.biFromHex(encryptionExponent);
    this.d = $dmath.biFromHex(decryptionExponent);
    this.m = $dmath.biFromHex(modulus);
    // We can do two bytes per digit, so
    // chunkSize = 2 * (number of digits in modulus - 1).
    // Since biHighIndex returns the high index, not the number of digits, 1 has
    // already been subtracted.
    this.digitSize = 2 * $dmath.biHighIndex(this.m) + 2;
    this.chunkSize = this.digitSize - 11;
    this.radix = 16;
    this.barrett = new $w.BarrettMu(this.m);
  };

  RSAUtils.getKeyPair = function (
    encryptionExponent,
    decryptionExponent,
    modulus
  ) {
    return new RSAKeyPair(encryptionExponent, decryptionExponent, modulus);
  };

  if (typeof $w.twoDigit === "undefined") {
    $w.twoDigit = function (n) {
      return (n < 10 ? "0" : "") + String(n);
    };
  }

  // Altered by Rob Saunders (rob@robsaunders.net). New routine pads the
  // string after it has been converted to an array. This fixes an
  // incompatibility with Flash MX's ActionScript.
  RSAUtils.encryptedString = function (key, s) {
    var a = [];
    var sl = s.length;

    var i = 0;
    while (i < sl) {
      a[i] = s.charCodeAt(i);
      i++;
    }

    var al = a.length;
    var result = "";
    var j, k, block;
    for (i = 0; i < al; i += key.chunkSize) {
      block = new BigInt();
      j = 0;

      // Add PKCS#1 v1.5 padding
      // 0x00 || 0x02 || PseudoRandomNonZeroBytes || 0x00 || Message
      // Variable a before padding must be of at most digitSize-11
      // That is for 3 marker bytes plus at least 8 random non-zero bytes
      var msgLength =
        i + key.chunkSize > al ? al % key.chunkSize : key.chunkSize;

      // Variable b with 0x00 || 0x02 at the highest index.
      var b = [];
      var x;
      for (x = 0; x < msgLength; x++) {
        b[x] = a[i + x];
      }
      b[msgLength] = 0; // marker

      var paddedSize = Math.max(8, key.digitSize - 3 - msgLength);
      for (x = 0; x < paddedSize; x++) {
        b[msgLength + 1 + x] = Math.floor(Math.random() * 254) + 1; // [1,255]
      }

      // It can be asserted that msgLength+paddedSize == key.digitSize-3
      b[key.digitSize - 2] = 2; // marker
      b[key.digitSize - 1] = 0; // marker

      for (k = 0; k < key.digitSize; ++j) {
        block.digits[j] = b[k++];
        block.digits[j] += b[k++] << 8;
      }
      var crypt = key.barrett.powMod(block, key.e);
      var text =
        key.radix === 16
          ? RSAUtils.biToHex(crypt)
          : RSAUtils.biToString(crypt, key.radix);
      result += text + " ";
    }
    var r = "";
    var blocks = result.split(" ");
    for (k = blocks.length; k >= 1; k--) {
      r += blocks[k - 1];
    }
    return r;
  };

  RSAUtils.decryptedString = function (key, s) {
    var blocks = s.split(" ");
    var result = "";
    var i, j, block;
    for (i = 0; i < blocks.length; ++i) {
      var bi;
      if (key.radix === 16) {
        bi = RSAUtils.biFromHex(blocks[i]);
      } else {
        bi = RSAUtils.biFromString(blocks[i], key.radix);
      }
      block = key.barrett.powMod(bi, key.d);
      for (j = 0; j <= RSAUtils.biHighIndex(block); ++j) {
        result += String.fromCharCode(
          block.digits[j] & 255,
          block.digits[j] >> 8
        );
      }
    }
    // Remove trailing null, if any.
    if (result.charCodeAt(result.length - 1) === 0) {
      result = result.substring(0, result.length - 1);
    }
    return result;
  };

  RSAUtils.setMaxDigits(130);
})(window);
///<jscompress sourcefile="url.js" />
(function (undefined) {
  var loc = window.location,
    href = loc.href,
    rHash = /\#.*$/;

  var Url = {
    removeHash: function (url) {
      return (url || href).replace(rHash, "");
    },
    getHash: function (url) {
      var match = (url || href).match(rHash);
      return match && match[0] ? match[0] : "";
    },
    removeParams: function (params, url) {
      url = url || href;

      var hash = Url.getHash(url),
        url = this.removeHash(url),
        i;

      for (i = params.length - 1; i >= 0; i--) {
        url = url.replace(
          new RegExp("(?:[\\?\\&](" + params[i] + "=[^&]*))", "g"),
          ""
        );
      }

      url =
        url
          .replace(/\&+/, "&")
          .replace(/[\&]+$/, "")
          .replace(/[\?]+$/, "") + hash;
      return /^[^?]*\&/.test(url) ? url.replace("&", "?") : url;
    },
    addParams: function (params, url) {
      url = url || href;

      var removeArr = [],
        addArr = [],
        hash = Url.getHash(url),
        url = this.removeHash(url),
        i;

      for (i in params) {
        if (params.hasOwnProperty(i)) {
          removeArr.push(i);
          addArr.push(i + "=" + encodeURIComponent(params[i]));
        }
      }

      url = this.removeParams(removeArr, url);
      return (
        url +
        (addArr[0]
          ? (url.indexOf("?") === -1 ? "?" : "&") + addArr.join("&")
          : "") +
        hash
      );
    },
    queryString: function (name, url) {
      var params = this.getParams(url);
      return params[name] != null ? params[name] : undefined;
    },
    getParams: function (url) {
      var search =
          url.indexOf("?") === -1
            ? []
            : url.substr(url.indexOf("?") + 1).split("&"),
        i = 0,
        len = search.length,
        params = {},
        pos;

      for (; i < len; i++) {
        pos = search[i].indexOf("=");
        if (pos > 0) {
          params[search[i].substring(0, pos)] = decodeURIComponent(
            search[i].substring(pos + 1)
          );
        }
      }
      return params;
    },
    getUrl: function () {
      return loc.protocol + "//" + loc.host + loc.pathname;
    },
    redirect: function (url) {
      loc.href = url;
      try {
        window.event.returnValue = false;
      } catch (e) {}
    },
  };

  window.Url = Url;
})();
///<jscompress sourcefile="sso.js" />
/*
 * 文件名: sso.js
 * 描述: 提供对 CAS 单点登录的封装
 * 版本: 1.35.0.1265-20210630
 *
 * 功能说明:
 * 实现多个应用之间的单点登录（SSO）功能,应用可以部署在不同的域名。
 *
 * 兼容性说明:
 * 此版本sdk,同时支持普通项目使用,以及前后端分离项目使用。
 *
 * 接口列表:
 * login,登录接口
 * loginExt,扩展登录接口
 * logout,登出接口
 * getLoginState,获取登录状态接口
 * validateServiceTicket,验证ST接口
 * getDeviceId,获取设备ID接口
 * getAccessToken,获取访问token接口
 *
 * 登录方式:
 * 1.普通登录(account,password)
 * 2.验证码登录(loginType,phoneNum,smsVerifyCode,smsCaptchaId,smsLoginType,smsCaptchaCode)
 * 3.TGT在线自动登录(account,loginType,mac,tgt,timestamp,username,signature)
 * 4.通用方式登录(loginType,genericValidateUserAttributes,genericUserInfoAttributes)
 * 5.免密登录(loginType,token,platformKey,signature)
 * 6.账号切换(account)
 *
 */

(function (undefined) {
  var SSO = {
    // 版本号，关联SSO服务端版本号-日期
    _version: config.getConfig().ssoConfig.version_num,
    // 用户服务所属用户组
    appName: config.getConfig().ssoConfig.appName,
    // 集成应用使用的appKey
    appKey: config.getConfig().ssoConfig.appKey,
    // 集成端的属性(web,pc,app)
    client: config.getConfig().ssoConfig.client,
    // 设备ID
    deviceId: getDeviceId(),
    // Mac地址
    mac: "",
    // Token的Scope范围(openapi/apigateway,空格分隔)
    scope: "openapi apigateway",
    // 当前连接SSO的服务地址
    SSOServerUrl: config.getConfig().ssoConfig.SSOServerUrl,
    // 登录后跳转服务地址(地址中appId参数会被解析)
    loginRedirectUrl: config.getConfig().ssoConfig.loginRedirectUrl,
    // 区域EDC项目需要修改
    SSOCenterServerUrl: config.getConfig().ssoConfig.SSOCenterServerUrl,
    // 当前连接的SSO是否是中心节点
    isCenterSSO: config.getConfig().ssoConfig.isCenterSSO,
    // tgt同步方式，1表示还是以前的同步方式，2表示使用同步组件来进行同步
    syncType: config.getConfig().ssoConfig.syncType,
    // 是否返回更多用户属性
    needAttribute: config.getConfig().ssoConfig.needAttribute,
    // 失败是否重试
    _retry: config.getConfig().ssoConfig._retry,
    // 登录方式
    loginType: config.getConfig().ssoConfig.loginType,
    // 自定义退出跳转地址 默认为空
    customLogoutUrl: "",
    // 是否自动匹配帐号类型,默认为null, 如果是true，则登录类型为auto
    accountTypeIsAuto: null,
    //央教管appId,登录如需上报需要填写
    ncetAppId: "",
    //央教管sysCode，非必填
    sysCode: "",
    //是否取获取nextpage参数作为service地址
    useNextPage: true,
    //nextpage是否需要base64解码，默认需要
    nextPageNeedBase64: true,
    //是否使用省内唯一准考证号，默认为false
    useAreaExamNo: false,
    //三方验证码类型
    thirdCaptchaType: "third",
    //图形验证码类型
    picCaptchaType: "pic",
    gtApiServers: "open.changyan.com",
    gtStaticServers: "open.changyan.com",
    gtProtocol: "https://",
    accountLoginVersion: "v2",
    needToken: true,

    login: function (account, password, callback) {
      SSOLogin(account, password, callback);
    },

    loginExt: function (loginObj, callback) {
      SSOLoginExt(loginObj, callback);
    },

    logout: function (callback) {
      SSOLogout(undefined, callback);
    },

    logoutExt: function (param, callback) {
      SSOLogout(param, callback);
    },

    getDeviceId: function (deviceId) {
      return getDeviceId(deviceId);
    },

    //获取登录状态并返回ST，兼容原版本
    getLoginState: function (callback) {
      return getLoginStatus(true, callback);
    },

    //获取登录状态并返回ST
    getLoginStateWithSt: function (callback) {
      return getLoginStatus(true, callback);
    },

    //获取登录状态不返回ST
    getLoginStateNoSt: function (callback) {
      return getLoginStatus(false, callback);
    },

    //获取token，appkey使用SSO.appKey
    getAccessToken: function (callback) {
      getTokenFromSSO(null, callback);
    },

    //获取token，参数可以指定appKey
    getAccessTokenWithParam: function (param, callback) {
      getTokenFromSSO(param, callback);
    },

    validateServiceTicket: function (st, service, callback) {
      validateServiceTicket(st, service, callback);
    },

    getSingleAccountTicket: function (param, callback) {
      getSingleATFromSSO(param, callback);
    },

    getOrRefreshSmsLoginCaptcha: function (param, callback) {
      getOrRefreshSmsLoginCaptcha(param, callback);
    },
    sendSms: function (param, callback) {
      sendSms(param, callback);
    },
    checkCaptcha: function (param, callback) {
      checkCaptcha(param, callback);
    },
    getCaptcha: function (param) {
      getCaptcha(param);
    },
    verify: function () {
      if (SSO.captchaObj) SSO.captchaObj.verify();
    },
    setCookie: function (name, value, expiredays) {
      setCookie(name, value, expiredays);
    },
  };

  window.SSO = window.SSO || SSO;

  /**
   * 获取或更新图形验证码
   * @param param isRefresh = true时为刷新
   * @param callback
   */
  function getOrRefreshSmsLoginCaptcha(param, callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl
    );
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/getSsoLoginCaptcha";
    var response = {};
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    if (param.service != undefined) {
      args.service = param.service;
    } else {
      args.service = SSO.loginRedirectUrl;
    }
    args.mac = param.mac || SSO.mac;
    var deviceId = param.deviceId || SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';
    if (param.isRefresh) {
      args.smsLoginCaptchaId = param.smsLoginCaptchaId;
    } else {
      var captchaCustomConfig = {
        width: param.width,
        height: param.height,
        textLength: param.textLength,
        textChars: param.textChars,
        fontSize: param.fontSize,
        fontColor: param.fontColor,
      };
      args.captchaCustomConfig = JSON.stringify(captchaCustomConfig);
    }

    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function (resultObj) {
        if (resultObj && resultObj.code === "success") {
          response.result = "success";
          response.code = resultObj.code;
          response.message = resultObj.message;
          response.data = resultObj.data;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function (resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
    });
  }

  /**
   * 校验图形验证码
   * @param param
   * @param callback
   */
  function checkCaptcha(param, callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl
    );
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/checkCaptcha";
    var response = {};
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    if (param.service != undefined) {
      args.service = param.service;
    } else {
      args.service = SSO.loginRedirectUrl;
    }
    args.mac = param.mac || SSO.mac;
    var deviceId = param.deviceId || SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';
    args.smsLoginCaptchaId = param.smsLoginCaptchaId;
    args.smsLoginCaptchaCode = param.smsLoginCaptchaCode;
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function (resultObj) {
        if (resultObj && resultObj.code === "success") {
          response.result = "success";
          response.code = resultObj.code;
          response.message = resultObj.message;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function (resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
    });
  }

  /**
   * 短信验证码发送
   * @param param
   * @param callback
   */
  function sendSms(param, callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl
    );
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/sendSms";
    var response = {};
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    if (param.service != undefined) {
      args.service = param.service;
    } else {
      args.service = SSO.loginRedirectUrl;
    }
    args.mac = param.mac || SSO.mac;
    var deviceId = param.deviceId || SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';
    args.smsLoginCaptchaId = param.smsLoginCaptchaId;
    args.smsLoginCaptchaCode = param.smsLoginCaptchaCode;
    args.mobile = param.mobile;
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function (resultObj) {
        if (resultObj && resultObj.code === "success") {
          response.result = "success";
        } else {
          response.result = "fail";
        }
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
      error: function (resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
    });
  }

  function getToken(resultObj, callback) {
    var response = {};
    // 尝试获取token
    var args = {};
    args.appKey = resultObj.appKey || SSO.appKey;
    args.tgt = resultObj.data.tgt;
    args.st = resultObj.data.st;
    args.service = SSO.loginRedirectUrl;
    args.client = SSO.client;
    args.mac = SSO.mac;
    args.scope = SSO.scope;
    var deviceId = SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';

    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/validationWeb";
    if (
      SSO.client === "pc" ||
      SSO.client === "app" ||
      SSO.client === "pc-web" ||
      SSO.client === "app-web"
    ) {
      SSOValidateUrl = SSO.SSOServerUrl + "/v1/validationV2";
    }

    //访问SSO服务地址,获取token
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function (resultObj) {
        if (
          resultObj &&
          resultObj.code === "1" &&
          resultObj.data &&
          resultObj.data.token
        ) {
          response.result = "success";
          response.code = resultObj.code;
          response.data = {
            token: resultObj.data.token,
            tgt: args.tgt,
            loginName: resultObj.data.loginName,
            userId: resultObj.data.userId,
            mergingUserId: resultObj.data.mergingUserId,
          };
          response.message = resultObj.message;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function (resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        response.data = { tgt: args.tgt };
        callback && callback(response);
      },
    });
  }

  function getSingleAT(param, callback) {
    var response = {};
    // 尝试获取at
    var args = {};
    args.appId = param.appKey || SSO.appKey;
    args.client = param.client || SSO.client;
    args.mac = param.mac || SSO.mac;
    args.needTicket = param.needTicket;
    var deviceId = param.deviceId || SSO.deviceId;
    if (deviceId) {
      args.extInfo = '{"deviceId": "' + deviceId + '"}';
    }
    if (param.destAppId) {
      args.destAppId = param.destAppId;
    } else {
      args.service = param.service || SSO.loginRedirectUrl;
    }

    if (param.tgt) {
      args.tgt = param.tgt;
      // 账号密码登录
    } else if (param.loginType === SSO.loginType.LOGINBYNORMAL) {
      var exponent = "010001";
      var modulus =
        "00ccd806a03c7391ee8f884f5902102d95f6d534d597ac42219dd8a79b1465e186c0162a6771b55e7be7422c4af494ba0112ede4eb00fc751723f2c235ca419876e7103ea904c29522b72d754f66ff1958098396f17c6cd2c9446e8c2bb5f4000a9c1c6577236a57e270bef07e7fe7bbec1f0e8993734c8bd4750e01feb21b6dc9";
      var key = RSAUtils.getKeyPair(exponent, "", modulus);
      args.type = param.loginType;
      args.username = param.account;
      args.password = RSAUtils.encryptedString(key, param.password);
      args.encodeType = "R2/P";
      args.encode = true;
      args.key = param.key || getAccountType(param.account, SSO.isCenterSSO);
      // 第三方免密登录
    } else if (param.loginType === SSO.loginType.LOGINBYTOKEN) {
      args.type = param.loginType;
      args.token = param.token;
      args.platformKey = param.platformKey;
      args.service = param.service || SSO.loginRedirectUrl;
      args.signature = param.signature;
    }else{
      // 注释
    }

    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/getSingleAt";
    //访问SSO服务地址,获取at
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function (resultObj) {
        if (
          resultObj &&
          resultObj.code === "success" &&
          resultObj.data &&
          resultObj.data.at
        ) {
          response.result = "success";
          response.code = resultObj.code;
          response.data = {
            at: resultObj.data.at,
            service: resultObj.data.service,
          };
          response.message = resultObj.message;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function (resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        response.data = { tgt: args.tgt };
        callback && callback(response);
      },
    });
  }

  function getTokenFromSSO(param, callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl
    );
    //获取当前用户登录状态
    getLoginStatus(true, function (resultObj) {
      if (resultObj && resultObj.result === "success") {
        if (param && param.appKey) {
          //如果传入appKey参数 使用传入的
          resultObj.appKey = param.appKey;
        }
        getToken(resultObj, callback);
      } else {
        callback && callback(resultObj);
      }
    });
  }

  function getLoginStatus(needServiceTicket, callback) {
    var response = {};
    var getStatusSsoUrl = SSO.SSOServerUrl + "/login";
    if (needServiceTicket && needServiceTicket === true) {
      getStatusSsoUrl = Url.addParams(
        { service: SSO.loginRedirectUrl },
        getStatusSsoUrl
      );
    }
    //访问SSO服务地址,获取当前SSO登录状态
    $.ajax({
      url: getStatusSsoUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function (html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          //已经登录了
          if (parseInt(resultObj.code) === 1001 && resultObj.data.tgt) {
            response.result = "success";
            response.code = resultObj.code;
            response.message = resultObj.message;
            response.data = {
              tgt: resultObj.data.tgt,
              st: resultObj.data.st,
              mergingUserId: resultObj.data.mergingUserId,
            };
            callback && callback(response);
            return;
          }
        }
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
      error: function (resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
    });
  }

  function analyseServiceURL() {
    var currentUrl = window.location.href;
    if (
      !SSO.useNextPage ||
      Url.queryString("nextpage", currentUrl) === undefined
    ) {
      SSO.loginRedirectUrl =
        SSO.needAttribute &&
        Url.queryString("from", SSO.loginRedirectUrl) === undefined
          ? Url.addParams({ from: "ew" }, SSO.loginRedirectUrl)
          : SSO.loginRedirectUrl;
    } else {
      var nextpageUrl = Url.queryString("nextpage", currentUrl);
      if (SSO.nextPageNeedBase64) {
        SSO.loginRedirectUrl = Base64.decode(nextpageUrl);
      } else {
        SSO.loginRedirectUrl = nextpageUrl;
      }
    }
    if (Url.queryString("client", currentUrl) !== undefined) {
      SSO.client = Url.queryString("client", currentUrl);
    }
    if (Url.queryString("appId", SSO.loginRedirectUrl) !== undefined) {
      SSO.appKey = Url.queryString("appId", SSO.loginRedirectUrl);
    }
  }

  function getLoginTicket(loginObj, callback) {
    var loginType = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
    var redirectUrl =
      loginType === SSO.loginType.LOGINBYCHANGEACCOUNT
        ? Url.addParams({ userChangeLogin: true }, SSO.loginRedirectUrl)
        : SSO.loginRedirectUrl;
    if (SSO.isCenterSSO === false) {
      var SSOCenterRestUrl =
        SSO.SSOCenterServerUrl +
        "/login?service=" +
        encodeURIComponent(redirectUrl);
      $.ajax({
        url: SSOCenterRestUrl,
        type: "GET",
        dataType: "jsonp",
        jsonp: "callback",
        crossDomain: true,
        cache: false,
        success: function (html) {
          html = $.trim(html).replace(/\t/g, "");
          var resultObj = evalJSON(html);
          if (resultObj.result && resultObj.result === "success") {
            //已经登录了
            if (
              parseInt(resultObj.code) === 1001 &&
              resultObj.data &&
              resultObj.data.st
            ) {
              if (
                (loginType !== SSO.loginType.LOGINBYONLINEAUTO ||
                  resultObj.data.tgt !== loginObj.tgt) &&
                loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT
              ) {
                CenterSSOLogout();
              }
            }
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    }
    var SSORestUrl =
      SSO.SSOServerUrl + "/login?service=" + encodeURIComponent(redirectUrl);
    $.ajax({
      url: SSORestUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function (html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          //已经登录了
          if (
            parseInt(resultObj.code) === 1001 &&
            resultObj.data &&
            resultObj.data.st
          ) {
            if (
              (loginType !== SSO.loginType.LOGINBYONLINEAUTO ||
                resultObj.data.tgt !== loginObj.tgt) &&
              loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT
            ) {
              SSOLogout(undefined, function () {
                setTimeout(function () {
                  getLoginTicket(loginObj, callback);
                }, 100);
              });
            }
            //新增用户切换登录
            else {
              var params = {
                lt: resultObj.data.lt,
                execution: resultObj.data.execution,
              };
              callback && callback(params);
            }
          } else {
            var params = {
              lt: resultObj.data.lt,
              execution: resultObj.data.execution,
            };
            callback && callback(params);
          }
        } else {
          callback && callback(undefined);
        }
      },
      error: function (data) {
        callback && callback(undefined);
      },
    });
  }

  function SSOLogin(account, password, callback) {
    var loginParam = {};
    loginParam.account = account;
    loginParam.password = password;
    SSOLoginExt(loginParam, callback);
  }

  function SSOLoginExt(loginObj, callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl
    );
    var loginType = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
    getLoginTicket(loginObj, function (ltParams) {
      if (
        ltParams === undefined &&
        loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT
      ) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "登录失败,出现异常！",
        };
        callback && callback(resultObj);
      } else {
        loginObj = loginObj || {};
        var pl = {};
        pl.captchaId = loginObj.captchaId || SSO.captchaId;
        pl.captchaType = loginObj.captchaType || SSO.captchaType;
        if (pl.captchaType == SSO.thirdCaptchaType) {
          pl.thirdCaptchaParam = JSON.stringify(SSO.captchaObj.getValidate());
        }
        pl.version = SSO.accountLoginVersion;
        pl.captchaCode = loginObj.captchaCode;
        pl.encode = true;
        pl.sourceappname = SSO.appName;
        pl._eventId = "submit";
        pl.appId = SSO.appKey;
        pl.client = loginObj.client || SSO.client;
        pl.type = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
        pl.key =
          loginObj.key || getAccountType(loginObj.account, SSO.isCenterSSO);
        pl.lt = ltParams.lt;
        pl.execution = ltParams.execution;
        pl.customLogoutUrl = ltParams.customLogoutUrl || SSO.customLogoutUrl;
        pl.ncetAppId = ltParams.ncetAppId || SSO.ncetAppId;
        pl.sysCode = ltParams.sysCode || SSO.sysCode;
        // 扩展信息字段
        if (loginObj.extInfo != null && loginObj.extInfo !== "") {
          pl.extInfo = loginObj.extInfo;
        } else if (
          SSO.client === "pc" ||
          SSO.client === "app" ||
          SSO.client === "pc-web" ||
          SSO.client === "app-web"
        ) {
          var deviceId = SSO.deviceId;
          pl.extInfo = '{"deviceId": "' + deviceId + '"}';
        }else{
          // 注释
        }
        var exponent = "010001";
        var modulus =
          "00ccd806a03c7391ee8f884f5902102d95f6d534d597ac42219dd8a79b1465e186c0162a6771b55e7be7422c4af494ba0112ede4eb00fc751723f2c235ca419876e7103ea904c29522b72d754f66ff1958098396f17c6cd2c9446e8c2bb5f4000a9c1c6577236a57e270bef07e7fe7bbec1f0e8993734c8bd4750e01feb21b6dc9";
        // 在线自动登录
        if (loginType === SSO.loginType.LOGINBYONLINEAUTO) {
          pl.username = loginObj.account;
          pl.mac = loginObj.mac || SSO.mac;
          pl.tgt = loginObj.tgt;
          pl.timestamp = loginObj.timestamp;
          pl.signature = loginObj.signature;
        }
        // 手机验证码登录
        else if (loginType === SSO.loginType.LOGINBYVERIFYCODE) {
          pl.phoneNum = loginObj.phoneNum;
          pl.smsVerifyCode = loginObj.smsVerifyCode;
          if (loginObj.smsCaptchaId) {
            pl.smsCaptchaId = loginObj.smsCaptchaId;
          }
        }
        // 通用登录
        else if (loginType === SSO.loginType.LOGINBYGENERIC) {
          pl.genericValidateUserAttributes =
            loginObj.genericValidateUserAttributes;
          pl.genericUserInfoAttributes = loginObj.genericUserInfoAttributes;
        }
        // 免密令牌登录
        else if (loginType === SSO.loginType.LOGINBYTOKEN) {
          pl.token = loginObj.token;
          pl.platformKey = loginObj.platformKey;
          pl.signature = loginObj.signature;
          pl.mac = loginObj.mac || SSO.mac;
        }
        //多账号免密切换登录
        else if (loginType === SSO.loginType.LOGINBYCHANGEACCOUNT) {
          pl.username = loginObj.account;
        }
        //央教馆登录
        else if (loginType === SSO.loginType.LOGINBYNCET) {
          if (loginObj.ticket) {
            pl.token = loginObj.ticket;
          } else if (loginObj.at) {
            pl.token = loginObj.at;
            pl.username = loginObj.account;
            var key = RSAUtils.getKeyPair(exponent, "", modulus);
            var password = "LT/" + ltParams.lt + "/" + loginObj.password;
            pl.encodeType = "R2/P/LT";
            pl.password = RSAUtils.encryptedString(key, password);
          }else{
            //注释
          }
          if (
            (loginObj.mac != null && loginObj.mac !== "") ||
            (SSO.mac != null && SSO.mac !== "")
          ) {
            pl.mac = loginObj.mac || SSO.mac;
          }
        }
        // 普通登录
        else {
          pl.username = loginObj.account;
          var key = RSAUtils.getKeyPair(exponent, "", modulus);
          var password = "LT/" + ltParams.lt + "/" + loginObj.password;
          pl.encodeType = "R2/P/LT";
          pl.password = RSAUtils.encryptedString(key, password);
          if (
            (loginObj.mac != null && loginObj.mac !== "") ||
            (SSO.mac != null && SSO.mac !== "")
          ) {
            pl.mac = loginObj.mac || SSO.mac;
          }
          pl.useAreaExamNo = loginObj.useAreaExamNo || SSO.useAreaExamNo;
          pl.areaCode = loginObj.areaCode;
          pl.personalName = loginObj.personalName;
        }
        var redirectUrl =
          loginType === SSO.loginType.LOGINBYCHANGEACCOUNT
            ? Url.addParams({ userChangeLogin: true }, SSO.loginRedirectUrl)
            : SSO.loginRedirectUrl;
        var SSORestUrl =
          SSO.SSOServerUrl +
          "/login?service=" +
          encodeURIComponent(redirectUrl);
        $.ajax({
          url: SSORestUrl,
          type: "GET",
          dataType: "jsonp",
          jsonp: "callback",
          data: pl,
          crossDomain: true,
          cache: false,
          success: function (html) {
            html = $.trim(html).replace(/\t/g, "");
            var resultObj = evalJSON(html);
            if (resultObj.result && resultObj.result === "success") {
              if (parseInt(resultObj.code) === 1000) {
                if (SSO._retry === false) {
                  //try again
                  SSO._retry = true;
                  SSOLoginExt(loginObj, callback);
                  return;
                }
                callback && callback(resultObj);
                return;
              }
              SSO._retry = false;
              resultObj.params = pl;
              if (SSO.needToken) {
                // 获取Token
                getToken(resultObj, function (resultObj) {
                  syncToCenter(resultObj, callback);
                });
              } else {
                syncToCenter(resultObj, callback);
              }
            } else {
              callback && callback(resultObj);
              return;
            }
          },
          error: function (data) {
            SSO._retry = false;
            var resultObj = {
              result: "fail",
              code: "-1",
              data: "登录失败,出现异常！",
            };
            callback && callback(resultObj);
          },
        });
      }
    });
  }

  function syncToCenter(resultObj, callback) {
    // sync TGT to centerSSO, only to ensure TGC added to center sso path
    if (SSO.isCenterSSO === false && SSO.syncType === 1) {
      syncToCenterSSO(resultObj.data.tgt, function () {
        callback && callback(resultObj);
      });
    } else if (SSO.isCenterSSO === false && SSO.syncType === 2) {
      syncToCenterSSO2(function () {
        callback && callback(resultObj);
      });
    } else {
      callback && callback(resultObj);
    }
  }

  function syncToCenterSSO(TGT, callback) {
    var SSORestUrl =
      SSO.SSOCenterServerUrl +
      "/login?ticketGrantingTicketIdFromAreaSSO=" +
      TGT;
    $.ajax({
      url: SSORestUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      timeout: 3000,
      complete: function () {
        callback && callback();
      },
    });
  }

  /**
   *  同步tgt到中心
   **/
  function syncToCenterSSO2(callback) {
    var syncUrl =
      SSO.SSOServerUrl +
      "/login?service=" +
      encodeURIComponent(
        Url.addParams({ isAjax: "true" }, SSO.loginRedirectUrl)
      ) +
      "&redirect=true";
    jQuery.ajax({
      url: syncUrl,
      type: "get",
      dataType: "jsonp",
      jsonp: "callback",
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      timeout: 3000,
      complete: function () {
        callback && callback();
      },
    });
  }

  function validateServiceTicket(st, service, callback) {
    if (st === undefined || service === undefined) {
      var resultObj = { result: "fail", code: "-1", data: "参数不合法" };
      callback && callback(resultObj);
      return;
    }
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/validation";
    var pl = {};
    pl.service = service;
    pl.ticket = st;
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      data: pl,
      crossDomain: true,
      cache: false,
      success: function (json) {
        callback && callback(json);
      },
      error: function (data) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "校验失败,出现异常！",
        };
        callback && callback(resultObj);
      },
    });
  }

  function getSingleATFromSSO(param, callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl
    );
    if (param.tgt || param.loginType) {
      getSingleAT(param, callback);
    } else {
      getLoginStatus(false, function (resultObj) {
        if (resultObj && resultObj.result === "success") {
          param.tgt = resultObj.data.tgt;
          getSingleAT(param, callback);
        } else {
          callback && callback(resultObj);
        }
      });
    }
  }

  function SSOLogout(param, callback) {
    var logoutURL = SSO.SSOServerUrl + "/logout";
    if (typeof param === "object") {
      logoutURL = param.tgtId
        ? Url.addParams({ tgtId: param.tgtId }, logoutURL)
        : logoutURL;
      logoutURL = param.clearScope
        ? Url.addParams({ clearScope: param.clearScope }, logoutURL)
        : logoutURL;
    }
    $.ajax({
      url: logoutURL,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function (html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          callback && callback(resultObj);
        }
      },
      error: function (data) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "登出失败,出现异常！",
        };
        callback && callback(resultObj);
      },
    });
  }

  function CenterSSOLogout() {
    var logoutURL = SSO.SSOCenterServerUrl + "/logout";
    $.ajax({
      url: logoutURL,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function (data) {
        console.log(data);
      },
      error: function (data) {
        console.log(data);
      },
    });
  }

  function getAccountType(account, isCenterSSO) {
    //accountTypeIsAuto 如果是true，则登录类型为auto
    if (
      SSO.accountTypeIsAuto === true ||
      (isCenterSSO === true && SSO.accountTypeIsAuto === null)
    ) {
      return "auto";
    }

    var REGEX_EMAIL = new RegExp(
      "^[0-9a-z]([._]?[0-9a-z])+@([0-9a-z][-\\w]*[0-9a-z]\\.)+[a-z]{2,9}$"
    );
    var REGEX_MOBILE = new RegExp("^1[3-9]\\d{9}$");
    var REGEX_EXAM_NO = new RegExp("^(\\d{8}|\\d{10})$"); //准考证号8位数字或10位数字
    var REGEX_STUDENT_EXAM_NO = new RegExp("^\\d{16}$"); //学籍号16位数字
    var type = "login_name";
    if (account === undefined) {
      return type;
    } else if (account.match(REGEX_EMAIL)) {
      type = "email";
    } else if (account.match(REGEX_MOBILE)) {
      type = "mobile";
    } else if (account.match(REGEX_EXAM_NO)) {
      type = "exam_no";
    } else if (account.match(REGEX_STUDENT_EXAM_NO)) {
      type = "student_enroll_no";
    }else{

    }
    return type;
  }

  function getDeviceId(deviceId) {
    // 主动设置deviceId
    if (!!deviceId) {
      setCookie("deviceId", deviceId, 365);
      //写入localStorage
      if (!!window.localStorage) {
        localStorage.setItem("deviceId", deviceId);
      }
    }
    // 获取deviceId
    if (!!window.localStorage) {
      deviceId = localStorage.getItem("deviceId");
    }
    if (!!deviceId) {
      //localstorage取到deviceId 设置到cookie中
      setCookie("deviceId", deviceId, 365);
    } else {
      //localstorage未取到deviceId
      //尝试cookie获取
      deviceId = getCookie("deviceId");
      if (!deviceId) {
        //未取到 生成随机值
        deviceId = Math.uuid();
        setCookie("deviceId", deviceId, 365);
      }
      //localstorage设置
      if (!!window.localStorage) {
        localStorage.setItem("deviceId", deviceId);
      }
    }
    return deviceId;
  }

  function evalJSON(s) {
    return eval("(" + s + ")");
  }

  function setCookie(name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie =
      name +
      "=" +
      escape(value) +
      (expiredays == null ? "" : ";path=/;expires=" + exdate.toGMTString());
  }

  function getCookie(name, base64) {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (document.cookie.match(reg)) {
      arr = document.cookie.match(reg);
      if (base64 === true) return Base64.decode(unescape(arr[2]));
      else return unescape(arr[2]);
    } else return null;
  }

  function getCaptcha(param) {
    console.log("极验方法被请求了");
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl
    );
    var SSOGetCaptchaUrl = SSO.SSOServerUrl + "/v1/getCaptcha";
    var SSOGetCaptchaTypeUrl = SSO.SSOServerUrl + "/v1/getCaptchaType";
    var args = {};
    args.appId = param.appId || SSO.appKey;
    args.client = param.client || SSO.client;
    console.log("SSOGetCaptchaTypeUrl", SSOGetCaptchaTypeUrl);
    $.ajax({
      url: SSOGetCaptchaTypeUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function (resultObj) {
        console.log("resultObj", resultObj);
        //如果返回的滑块 初始化
        if (resultObj && resultObj.code === "success" && resultObj.data) {
          var captchaConf = evalJSON(resultObj.data.captchaConf);
          SSO.captchaType = captchaConf.captchaType;
          //如果返回的type滑块（third）
          console.log("请求成功了");
          console.log("captchaConf.captchaType", captchaConf.captchaType);
          if (captchaConf.captchaType === "third") {
            param.gt = param.gt || captchaConf.gt;
            createGt(captchaConf);
          } else {
            sucWeb.callCB(getPic, param);
          }
        } else {
          sucWeb.callCB(getPic, param);
        }
      },
      error: function () {
        console.warn("请求错误了");
        sucWeb.callCB(getPic, param);
      },
      fail: function () {
        console.error("请求失败了");
        sucWeb.callCB(getPic, param);
      },
    });

    function createGt(resultData) {
      if (!resultData.apiServers || resultData.apiServers.length == 0) {
        resultData.apiServers = ["gcaptcha4.geetest.com"];
      }
      if (!resultData.staticServers || resultData.staticServers.length == 0) {
        resultData.staticServers = [
          "static.geetest.com",
          "dn-staticdown.qbox.me",
        ];
      }
      if (resultData.gtProtocol) {
        if (resultData.gtProtocol.match("https")) {
          resultData.gtProtocol = "https://";
        } else {
          resultData.gtProtocol = "http://";
        }
      }
      SSO.captchaObj = new sucWeb.ui.createGt({
        param: param,
        protocol: resultData.gtProtocol || "https://",
        ssoApiServers: resultData.apiServers,
        ssoStaticServers: resultData.staticServers,
        cbs: {
          onSuccess: param.captchaSuccessResultCB,
          onReady: param.getCaptchaResultCB,
          onError: param.thirdCaptchaErrorCB,
          onClose: param.captchaCloseCB,
          initFail: getPic,
        },
      });
      console.log("SSO.captchaObj", SSO.captchaObj);
    }

    function getPic(param) {
      var response = {};
      if (param.service != undefined) {
        args.service = param.service;
      } else {
        args.service = SSO.loginRedirectUrl;
      }
      args.mac = param.mac || SSO.mac;
      var deviceId = param.deviceId || SSO.deviceId;
      args.extInfo = '{"deviceId": "' + deviceId + '"}';
      var captchaCustomConfig = {
        width: param.width,
        height: param.height,
        textLength: param.textLength,
        textChars: param.textChars,
        fontSize: param.fontSize,
        fontColor: param.fontColor,
      };
      args.captchaCustomConfig = JSON.stringify(captchaCustomConfig);
      if (SSO.captchaId) {
        args.captchaId = SSO.captchaId;
      }
      $.ajax({
        url: SSOGetCaptchaUrl,
        type: "GET",
        dataType: "jsonp",
        jsonp: "callback",
        crossDomain: true,
        cache: false,
        data: args,
        success: function (resultObj) {
          //如果返回的滑块 初始化
          if (resultObj && resultObj.code === "success" && resultObj.data) {
            response.result = "success";
            response.code = resultObj.code;
            response.message = resultObj.message;
            response.data = resultObj.data;
            SSO.captchaId = resultObj.data.captchaId;
            SSO.captchaType = resultObj.data.captchaType;
            sucWeb.callCB(param.getCaptchaResultCB, response);
          } else {
            response.result = "fail";
            response.code = resultObj.code;
            response.message = resultObj.message;
            sucWeb.callCB(param.getCaptchaResultCB, response);
          }
          // callback && callback(response);
        },
        error: function (resultObj) {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
          sucWeb.callCB(param.getCaptchaResultCB, response);
        },
      });
    }
  }
})();
///<jscompress sourcefile="suc_gt.js" />

window.sucWeb = {};
sucWeb.clazz = function (p, c) {
  if (arguments.length < 2) {
    c = p;
    p = null;
  } else if (typeof p !== "function" && console)
    console.trace("Error : unkonw parent class");

  function core(d, o, flag) {
    var x = this;
    this.uedo = true;

    if (typeof o != "object") o = { uedo: true };
    d = d || {};

    var t = core.prototype;
    if (typeof p == "function") x._ = p.prototype;
    if ("inborn" in t) t.inborn.call(x, d);
    if (typeof p == "function") p.call(x, d, o, true);
    if (!x.access)
      x.access = function (n, f, r) {
        o[n] = function () {
          var tmp = f.apply(x, arguments);
          if (r) return o;
          return tmp;
        };
        return x;
      };
    if (typeof p == "function") x._ = p.prototype;
    if ("born" in t) t.born.call(x, d);

    if (!flag && typeof o.getDom == "function") {
      switch (sucWeb.type(o.getDom())) {
        case "dom":
        case "window":
        case "global":
          o.getDom().obj = o;
          break;
        default:
          break;
      }
    }

    return o;
  }

  if (typeof p == "function") {
    var pt = function () {};
    pt.prototype = p.prototype;
    core.prototype = new pt();
  }
  if (typeof c == "object") for (var k in c) core.prototype[k] = c[k];

  return core;
};

sucWeb.callCB = function (f) {
  if (typeof f == "function")
    f.apply(this, Array.prototype.slice.call(arguments, 1));
  else if (typeof f == "object" && f != null && typeof f.cb == "function") {
    if (typeof f.scope == "object")
      f.cb.apply(f.scope, Array.prototype.slice.call(arguments, 1));
    else f.cb.apply(this, Array.prototype.slice.call(arguments, 1));
  } else return false;

  return true;
};

sucWeb.type = function (t) {
  if (t === null) return "null";
  if (typeof t === "object") {
    if (t.window && t.window.window && t.window === t.window.window)
      return "window";
    if (t.nodeType === 1 && typeof t.nodeName === "string") return "dom";
    return Object.prototype.toString.call(t).slice(8, -1).toLowerCase();
  }
  return typeof t;
};

sucWeb.define = function (s, d) {
  if (s == null) return d;
  if (d == null) return s;

  if (sucWeb.type(s) !== sucWeb.type(d)) return d;

  switch (sucWeb.type(d)) {
    case "object":
    case "array":
      for (var i in d) s[i] = sucWeb.define(s[i], d[i]);
      return s;
  }

  return s;
};

sucWeb.ns = function (path) {
  if (typeof path != "string") return;
  var arr = path.split(".");
  var ns = arr[0];
  eval("if(typeof(" + ns + ")=='undefined') " + ns + "={};");
  for (var i = 1; i < arr.length; i++) {
    ns += "." + arr[i];
    eval("if(typeof(" + ns + ")=='undefined') " + ns + "={};");
  }
  return sucWeb;
};

sucWeb.ns("sucWeb.ui");
sucWeb.ui.createGt = sucWeb.clazz({
  born: function (_c) {
    this.c = sucWeb.define(_c, {
      product: "bind",
      width: "300px",
      lang: "zh-cn",
      https: false,
      timeout: 30000,
      zoomEle: null,
      hideSuccess: false,
      hideClose: false,
      hideRefresh: false,
      parent: "",
      bindForm: "",
      ssoApiServers: [],
      ssoStaticServers: [],
      param: null,
      cbs: {
        initFail: null,
        onReady: null,
        onSuccess: null,
        onError: null,
        onClose: null,
      },
    });
    this.init();
    this.access("reset", this.reset)
      .access("destroy", this.destroy)
      .access("verify", this.verify)
      .access("getCaptchaObj", this.getCaptchaObj)
      .access("getValidate", this.getValidate);
  },
  initGt: function () {
    var o = this;
    (function (window, apiServers, staticServers) {
      "use strict";
      if (typeof window === "undefined") {
        throw new Error("Geetest requires browser environment");
      }

      var document = window.document;
      var Math = window.Math;
      var head = document.getElementsByTagName("head")[0];
      var TIMEOUT = 10000;

      function _Object(obj) {
        this._obj = obj;
      }

      _Object.prototype = {
        _each: function (process) {
          var _obj = this._obj;
          for (var k in _obj) {
            if (_obj.hasOwnProperty(k)) {
              process(k, _obj[k]);
            }
          }
          return this;
        },
        _extend: function (obj) {
          var self = this;
          new _Object(obj)._each(function (key, value) {
            self._obj[key] = value;
          });
        },
      };

      var uuid = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        );
      };

      function Config(config) {
        var self = this;
        new _Object(config)._each(function (key, value) {
          self[key] = value;
        });
      }

      Config.prototype = {
        apiServers: apiServers,
        staticServers: staticServers,
        protocol: "http://",
        typePath: "/load",
        fallback_config: {
          bypass: {
            staticServers: ["static.geetest.com/", "dn-staticdown.qbox.me/"],
            type: "bypass",
            bypass: "/v4/bypass.js",
          },
        },
        _get_fallback_config: function () {
          var self = this;
          if (isString(self.type)) {
            return self.fallback_config[self.type];
          } else {
            return self.fallback_config.bypass;
          }
        },
        _extend: function (obj) {
          var self = this;
          new _Object(obj)._each(function (key, value) {
            self[key] = value;
          });
        },
      };
      var isNumber = function (value) {
        return typeof value === "number";
      };
      var isString = function (value) {
        return typeof value === "string";
      };
      var isBoolean = function (value) {
        return typeof value === "boolean";
      };
      var isObject = function (value) {
        return typeof value === "object" && value !== null;
      };
      var isFunction = function (value) {
        return typeof value === "function";
      };
      var MOBILE = /Mobi/i.test(navigator.userAgent);
      var pt = MOBILE ? 3 : 0;

      var callbacks = {};
      var status = {};

      var random = function () {
        return parseInt(Math.random() * 10000) + new Date().valueOf();
      };

      // bind 函数polify, 不带new功能的bind

      var bind = function (target, context) {
        if (typeof target !== "function") {
          return;
        }
        var args = Array.prototype.slice.call(arguments, 2);

        if (Function.prototype.bind) {
          return target.bind(context, args);
        } else {
          return function () {
            var _args = Array.prototype.slice.call(arguments);
            return target.apply(context, args.concat(_args));
          };
        }
      };

      var toString = Object.prototype.toString;

      var _isFunction = function (obj) {
        return typeof obj === "function";
      };
      var _isObject = function (obj) {
        return obj === Object(obj);
      };
      var _isArray = function (obj) {
        return toString.call(obj) == "[object Array]";
      };
      var _isDate = function (obj) {
        return toString.call(obj) == "[object Date]";
      };
      var _isRegExp = function (obj) {
        return toString.call(obj) == "[object RegExp]";
      };
      var _isBoolean = function (obj) {
        return toString.call(obj) == "[object Boolean]";
      };

      function resolveKey(input) {
        return input.replace(
          /(\S)(_([a-zA-Z]))/g,
          function (match, $1, $2, $3) {
            return $1 + $3.toUpperCase() || "";
          }
        );
      }

      function camelizeKeys(input, convert) {
        if (
          !_isObject(input) ||
          _isDate(input) ||
          _isRegExp(input) ||
          _isBoolean(input) ||
          _isFunction(input)
        ) {
          return convert ? resolveKey(input) : input;
        }

        if (_isArray(input)) {
          var temp = [];
          for (var i = 0; i < input.length; i++) {
            temp.push(camelizeKeys(input[i]));
          }
        } else {
          var temp = {};
          for (var prop in input) {
            if (input.hasOwnProperty(prop)) {
              temp[camelizeKeys(prop, true)] = camelizeKeys(input[prop]);
            }
          }
        }
        return temp;
      }

      var loadScript = function (url, cb, timeout) {
        var script = document.createElement("script");
        script.charset = "UTF-8";
        script.async = true;

        // 对geetest的静态资源添加 crossOrigin
        if (/static\.geetest\.com/g.test(url)) {
          script.crossOrigin = "anonymous";
        }

        script.onerror = function () {
          cb(true);
          // 错误触发了，超时逻辑就不用了
          loaded = true;
        };
        var loaded = false;
        script.onload = script.onreadystatechange = function () {
          if (
            !loaded &&
            (!script.readyState ||
              "loaded" === script.readyState ||
              "complete" === script.readyState)
          ) {
            loaded = true;
            setTimeout(function () {
              cb(false);
            }, 0);
          }
        };
        script.src = url;
        head.appendChild(script);

        setTimeout(function () {
          if (!loaded) {
            script.onerror = script.onload = null;
            script.remove && script.remove();
            cb(true);
          }
        }, timeout || TIMEOUT);
      };

      var normalizeDomain = function (domain) {
        // special domain: uems.sysu.edu.cn/jwxt/geetest/
        // return domain.replace(/^https?:\/\/|\/.*$/g, ''); uems.sysu.edu.cn
        return domain.replace(/^https?:\/\/|\/$/g, ""); // uems.sysu.edu.cn/jwxt/geetest
      };
      var normalizePath = function (path) {
        path = path.replace(/\/+/g, "/");
        if (path.indexOf("/") !== 0) {
          path = "/" + path;
        }
        return path;
      };
      var normalizeQuery = function (query) {
        if (!query) {
          return "";
        }
        var q = "?";
        new _Object(query)._each(function (key, value) {
          if (isString(value) || isNumber(value) || isBoolean(value)) {
            q =
              q +
              encodeURIComponent(key) +
              "=" +
              encodeURIComponent(value) +
              "&";
          }
        });
        if (q === "?") {
          q = "";
        }
        return q.replace(/&$/, "");
      };
      var makeURL = function (protocol, domain, path, query) {
        domain = normalizeDomain(domain);

        var url = normalizePath(path) + normalizeQuery(query);
        if (domain) {
          url = protocol + domain + url;
        }

        return url;
      };

      var load = function (
        config,
        protocol,
        domains,
        path,
        query,
        cb,
        handleCb
      ) {
        var tryRequest = function (at) {
          // 处理jsonp回调，这里为了保证每个不同jsonp都有唯一的回调函数
          if (handleCb) {
            var cbName = "geetest_" + random();
            // 需要与预先定义好cbname参数，删除对象
            window[cbName] = bind(handleCb, null, cbName);
            query.callback = cbName;
          }
          var url = makeURL(protocol, domains[at], path, query);
          loadScript(
            url,
            function (err) {
              if (err) {
                // 超时或者出错的时候 移除回调
                if (cbName) {
                  try {
                    window[cbName] = function () {
                      window[cbName] = null;
                    };
                  } catch (e) {}
                }

                if (at >= domains.length - 1) {
                  cb(true);
                  // report gettype error
                } else {
                  tryRequest(at + 1);
                }
              } else {
                cb(false);
              }
            },
            config.timeout
          );
        };
        tryRequest(0);
      };

      var jsonp = function (domains, path, config, callback) {
        var handleCb = function (cbName, data) {
          // 保证只执行一次，全部超时的情况下不会再触发;

          if (data.status == "success") {
            callback(data.data);
          } else if (!data.status) {
            callback(data);
          } else {
            //接口有返回，但是返回了错误状态，进入报错逻辑
            callback(data);
          }
          window[cbName] = undefined;
          try {
            delete window[cbName];
          } catch (e) {}
        };

        load(
          config,
          config.protocol,
          domains,
          path,
          {
            captcha_id: config.captchaId,
            challenge: config.challenge || uuid(),
            client_type: 0,
            pt: 0,
            risk_type: config.riskType,
          },
          function (err) {
            // 网络问题接口没有返回，直接使用本地验证码，走宕机模式
            // 这里可以添加用户的逻辑
            if (err && typeof config.offlineCb === "function") {
              // 执行自己的宕机
              config.offlineCb();
              return;
            }

            if (err) {
              callback(config._get_fallback_config());
            }
          },
          handleCb
        );
      };

      var reportError = function (config, url) {
        load(
          config,
          config.protocol,
          ["monitor.geetest.com"],
          "/monitor/send",
          {
            time: Date.now().getTime(),
            captcha_id: config.gt,
            challenge: config.challenge,
            pt: pt,
            exception_url: url,
            error_code: config.error_code,
          },
          function (err) {}
        );
      };

      var throwError = function (errorType, config, errObj) {
        var errors = {
          networkError: "网络错误",
          gtTypeError: "gt字段不是字符串类型",
        };
        if (typeof config.onError === "function") {
          config.onError({
            desc: errObj.desc,
            msg: errObj.msg,
            code: errObj.code,
          });
        } else {
          throw new Error(errors[errorType]);
        }
      };

      var detect = function () {
        return window.Geetest || document.getElementById("gt_lib");
      };

      if (detect()) {
        status.slide = "loaded";
      }

      window.initGeetest4 = function (userConfig, callback) {
        var config = new Config(userConfig);
        if (userConfig.https) {
          config.protocol = "https://";
        } else if (!userConfig.protocol) {
          config.protocol = window.location.protocol + "//";
        }else{

        }

        if (isObject(userConfig.getType)) {
          config._extend(userConfig.getType);
        }

        jsonp(config.apiServers, config.typePath, config, function (newConfig) {
          //错误捕获，第一个load请求可能直接报错
          var newConfig = camelizeKeys(newConfig);

          if (newConfig.status === "error") {
            return throwError("networkError", config, newConfig);
          }

          var type = newConfig.type;

          if (config.debug) {
            new _Object(newConfig)._extend(config.debug);
          }
          var init = function () {
            config._extend(newConfig);
            callback(new window.Geetest4(config));
          };

          callbacks[type] = callbacks[type] || [];

          var s = status[type] || "init";
          if (s === "init") {
            status[type] = "loading";

            callbacks[type].push(init);

            if (newConfig.gctPath) {
              load(
                config,
                config.protocol,
                Object.hasOwnProperty(config.staticServers)
                  ? config.staticServers
                  : newConfig.staticServers || config.staticServers,
                newConfig.gctPath,
                null,
                function (err) {
                  if (err) {
                    throwError("networkError", config, {
                      code: "60205",
                      msg: "Network failure",
                      desc: {
                        detail: "gct resource load timeout",
                      },
                    });
                  }
                }
              );
            }

            load(
              config,
              config.protocol,
              Object.hasOwnProperty(config.staticServers)
                ? config.staticServers
                : newConfig.staticServers || config.staticServers,
              newConfig.bypass || newConfig.staticPath + newConfig.js,
              null,
              function (err) {
                if (err) {
                  status[type] = "fail";
                  throwError("networkError", config, {
                    code: "60204",
                    msg: "Network failure",
                    desc: {
                      detail: "js resource load timeout",
                    },
                  });
                } else {
                  status[type] = "loaded";
                  var cbs = callbacks[type];
                  for (var i = 0, len = cbs.length; i < len; i = i + 1) {
                    var cb = cbs[i];
                    if (isFunction(cb)) {
                      cb();
                    }
                  }
                  callbacks[type] = [];
                }
              }
            );
          } else if (s === "loaded") {
            return init();
          } else if (s === "fail") {
            throwError("networkError", config),
              {
                code: "60204",
                msg: "Network failure",
                desc: {
                  detail: "js resource load timeout",
                },
              };
          } else if (s === "loading") {
            callbacks[type].push(init);
          }else{

          }
        });
      };
    })(window, o.c.ssoApiServers, o.c.ssoStaticServers);
  },
  init: function () {
    var o = this;
    o.initGt();
    var gtData = JSON.parse(JSON.stringify(o.c));
    delete gtData.param;
    delete gtData.cbs;
    gtData.captchaId = o.c.param.gt;
    gtData.offline = false;
    gtData["new_captcha"] = true;
    gtData.offlineCb = function () {
      sucWeb.callCB(o.c.cbs.initFail, o.c.param);
    };
    console.log("极验初始化前调用");
    o.initGeetest(gtData);
  },
  getValidate: function () {
    return this.validateCodeObj;
  },
  getValidateCodeObj: function () {
    return this.captchaObj.getValidate();
  },
  initGeetest: function (data) {
    console.log("初始化吉言方法");
    var o = this;
    initGeetest4(data, function (captchaObj) {
      o.captchaObj = captchaObj;
      if (o.c.parent) {
        captchaObj.appendTo(o.c.parent);
      }
      captchaObj
        .onSuccess(function () {
          o.validateCodeObj = o.getValidateCodeObj(captchaObj);
          if (o.c.cbs.onSuccess) {
            sucWeb.callCB(o.c.cbs.onSuccess, o.validateCodeObj);
          } else {
            sucWeb.callCB(o.onSuccess, o.validateCodeObj);
          }
        })
        .onError(function (error) {
          if (o.c.cbs.onError) {
            sucWeb.callCB(o.c.cbs.onError, error);
          } else {
            sucWeb.callCB(o.onError, error);
          }
        })
        .onReady(function () {
          if (o.c.cbs.onReady) {
            var response = {};
            response.result = "success";
            response.code = "success";
            response.data = { captchaType: "third" };
            sucWeb.callCB(o.c.cbs.onReady, response);
          }
        })
        .onClose(function () {
          if (o.c.cbs.onClose) {
            sucWeb.callCB(o.c.cbs.onClose);
          } else {
            sucWeb.callCB(o.onClose);
          }
        });
    });
  },
  onSuccess: function (result) {},
  onError: function (error) {},
  onClose: function () {},
  getCaptchaObj: function () {
    return this.captchaObj;
  },
  reset: function () {
    console.log("图形重置");
    this.captchaObj.reset();
  },
  destroy: function () {
    console.log("图形销毁");
    this.captchaObj.destroy();
  },
  verify: function () {
    console.log("展示图形");
    this.captchaObj.showBox();
  },
});



// WEBPACK FOOTER //
// ./src/api/sso/sso.js